import { render, staticRenderFns } from "./servicio.vue?vue&type=template&id=c52e4aea&"
import script from "./servicio.vue?vue&type=script&lang=js&"
export * from "./servicio.vue?vue&type=script&lang=js&"
import style0 from "vue-swatches/dist/vue-swatches.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports